// tslint:disable:max-line-length

import React from 'react';

export const DatatypeText = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,9.23C0,7.8,1.32,6.8,3.09,6.4V6.11c0-.48-.13-.7-.55-.7a2.49,2.49,0,0,0-1.45.73L.23,5.05A3.75,3.75,0,0,1,2.84,4c1.42,0,1.93.7,1.93,2.08V9.31A6.61,6.61,0,0,0,4.91,11H3.19a3.36,3.36,0,0,1-.1-.91,1.81,1.81,0,0,1-1.61,1C.66,11.06,0,10.53,0,9.23Zm3.05,0V7.61C2.14,7.89,1.7,8.39,1.7,9s.21.68.53.68A1.36,1.36,0,0,0,3.09,9.23Z" />
      <path d="M7.39,10.19V11H5.65V1.39H7.39V4.9A1.75,1.75,0,0,1,8.85,4c1.1,0,1.83,1,1.83,3.56s-.74,3.55-1.84,3.55A1.65,1.65,0,0,1,7.39,10.19ZM8.91,7.54c0-1.56-.22-2-.75-2a1.18,1.18,0,0,0-.77.44V9.21a1.09,1.09,0,0,0,.78.44C8.68,9.65,8.91,9.15,8.91,7.54Z" />
      <path d="M11.07,7.54C11.07,5,12.18,4,13.61,4s2.08,1,2.3,2.41l-1.6.25c-.13-.86-.27-1.3-.72-1.3s-.79.53-.79,2.21.21,2.25.79,2.25.65-.4.78-1.38l1.56.22c-.22,1.49-.89,2.47-2.36,2.47S11.07,10,11.07,7.54Z" />
      <rect y="13" width="16" height="2" />
    </svg>
  );
};
